import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import {
  Route, Redirect, Switch, withRouter,
} from 'react-router-dom';

import {
  Header, Footer, AnonymousRoute, PrivateRoute, Cookie,
} from '@app/components';
import {
  Login, Home, Subscribe, Devices, Subscription, MyAccount, ForgotPassword, ForgotPasswordConfirm,
} from '@app/pages';
import RouterConstants from '@app/constants/router';
import { setAccountValidationParams } from '@app/actions/accountActions';

class App extends React.Component {
  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const prevLocation = get(prevProps, 'location', '');

    if (location !== prevLocation) {
      window.scroll({
        behavior: 'smooth',
        left: 0,
        top: 0,
      });
    }
  }

  render() {
    const {
      setAccountValidationParams, isLoggedIn,
    } = this.props;

    return (
      <Application>
        <Header />
        <Main>
          <Switch>
            <Route exact path={RouterConstants.HOME} component={Home} />
            <AnonymousRoute path={RouterConstants.SIGN_IN} component={Login} />
            <AnonymousRoute exact path={RouterConstants.FORGOT_PASSWORD} component={ForgotPassword} />
            <AnonymousRoute exact path={RouterConstants.FORGOT_PASSWORD_CONFIRM} component={ForgotPasswordConfirm} />
            <Route path={RouterConstants.SUBSCRIBE} component={Subscribe} />
            <Route
              path={RouterConstants.SIGN_UP_CONFIRM_REDIRECT}
              render={() => {
                if (isLoggedIn) {
                  return (
                    <Redirect to={{ pathname: RouterConstants.HOME }} />
                  );
                }

                const { searchParams } = new URL(document.location);

                setAccountValidationParams({
                  email: searchParams.get('email'),
                  idHash: searchParams.get('idHash'),
                  token: searchParams.get('token'),
                });

                return (
                  <Redirect
                    to={RouterConstants.SIGN_UP_CONFIRM}
                  />
                );
              }}
            />
            <PrivateRoute exact path={RouterConstants.ACCOUNT} component={MyAccount} />
            <PrivateRoute path={RouterConstants.ACCOUNT_DEVICES} component={Devices} />
            <PrivateRoute path={RouterConstants.ACCOUNT_SUBSCRIPTION} component={Subscription} />
            <Route render={() => (<Redirect to={RouterConstants.HOME} />)} />
          </Switch>
        </Main>
        <Footer />
        <Cookie />
      </Application>
    );
  }
}

App.propTypes = {
  setAccountValidationParams: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  location: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

const mapStateToProps = ({
  user: { isLoggedIn },
}) => ({
  isLoggedIn,
});

export default withRouter(connect(mapStateToProps, { setAccountValidationParams })(App));

const Application = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 75px;
  width: 100%;
  height: 100%;
`;

const Main = styled.div`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  width: 100%;
`;
